module.exports = __webpack_public_path__ + "media/images/arrows/twisted/green-down-left-a7d8b8f316c7b18a705e83878855a679.svg";